import { render, staticRenderFns } from "./ThgBillingDetailResultsCard.vue?vue&type=template&id=151dafb4&"
import script from "./ThgBillingDetailResultsCard.vue?vue&type=script&lang=ts&"
export * from "./ThgBillingDetailResultsCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports